module.exports = __webpack_public_path__ + "static/media/logo.bb3dc68c.png";